// 초대 토큰을 인증 절차 동안 보관한다.
//
// 왜 필요한가 (실측 2026-08-24 운영):
//   초대받은 사람이 링크를 눌렀는데 **계정이 없었다.** 수락 화면은 '로그인하러 가기'만
//   보여줬고, 그 버튼을 누르는 순간 URL 프래그먼트의 토큰이 사라졌다. 그 사람은
//   일반 가입 절차를 밟아 **자기 개인 작업 공간만 새로 만들고** 끝났다 —
//   초대는 그대로 대기 상태로 남았고 조직에는 합류하지 않았다.
//
//   토큰을 보관해 두면 로그인·가입·소셜 로그인 **어느 길로 돌아와도** 수락으로 이어진다.
//
// ⚠️ `sessionStorage` 를 쓴다. `localStorage` 는 탭을 닫아도 남아, 나중에 전혀 다른
//    맥락에서 엉뚱한 조직에 합류시킬 수 있다. 초대는 그 자리에서 끝나야 하는 일이다.
const KEY = "taplink.pendingInvitation";

/** 인증 절차로 넘어가기 전에 맡겨 둔다 */
export function rememberInvitation(token: string): void {
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    // 시크릿 모드 등에서 막힐 수 있다 — 보관에 실패해도 화면은 계속 동작해야 한다.
    // 그때는 메일 링크를 다시 누르는 것이 길이다(수락 화면이 그 안내를 한다).
  }
}

/** 맡긴 것이 있는지만 본다 — 지우지 않는다 */
export function peekInvitation(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** 꺼내고 **지운다.** 두 번 수락을 시도하지 않기 위해서다 */
export function takeInvitation(): string | null {
  const token = peekInvitation();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* 위와 같다 */
  }
  return token;
}
